import {
    SET_AUTH_ERROR,
    CREATE_NEW_PASSWORD,
    REQUEST_PASSWORD_RESET,
    SET_AUTH_SUCCESS,
    CHANGE_PASSWORD
} from './actionType';

// import { LOGIN_USER, LOGOUT_USER } from './actionType';
// export const loginUser = data => {
//     return {
//         type: LOGIN_USER,
//         payload: data
//     };
// };
// export const logoutUser = data => {
//     return {
//         type: LOGOUT_USER,
//         payload: data
//     };
// };

export const requestPasswordReset = data => {
    return {
        type: REQUEST_PASSWORD_RESET,
        payload: data
    };
};

export const createNewPassword = data => {
    return {
        type: CREATE_NEW_PASSWORD,
        payload: data
    };
};

// TODO: Delete after final refactoring ->
export const setAuthError = data => {
    return {
        type: SET_AUTH_ERROR,
        payload: data
    };
};

// TODO: Delete after final refactoring ->
export const setAuthSuccess = data => {
    return {
        type: SET_AUTH_SUCCESS,
        payload: data
    };
};

export const changePassword = data => {
    return {
        type: CHANGE_PASSWORD,
        payload: data
    };
};
